<template>
  <SdsPaginator
    :current-page="currentPage"
    :total-pages="urls.length"
    @go-to-page="goToPage"
  />
</template>

<script setup lang="ts">
import { inject } from 'vue'

interface PaginatorDataset {
  urls: string;
  currentPage: string;
}

const dataset = inject<PaginatorDataset>('dataset')
const urls: string[] = dataset ? JSON.parse(dataset.urls) : []
const currentPage = dataset ? parseInt(dataset.currentPage, 10) : 1

// Each page maps to a server-rendered URL, so paging is a full navigation
function goToPage({ page }: { page: number }) {
  const url = urls[page - 1]
  if (url && page !== currentPage) window.location.assign(url)
}

defineOptions({
  name: "GenericPaginator"
})
</script>
